module.exports = __webpack_public_path__ + "static/pistol-ebdfae28eaf62fd5700d254f80ffb534.gif";